import { types } from "../types/types";
const init = {
    loadingCampaniaServicios:false,
    loadingCampaniaMateriales:false,
    uploadingCampaniaMaterial:false,
    deletingCampaniaMaterial:false,
    loadingCampos: false
}
export const loadingReducer = (state = init, action) => {
  switch (action.type) {
    case types.setLoadingCampaniaServicios:
      return {
        ...state,
        loadingCampaniaServicios: action.payload,
      };

    case types.setLoadingCampaniaMateriales:
      return {
        ...state,
        loadingCampaniaMateriales: action.payload,
      };

    case types.setUploadingCampaniaMaterial:
      return {
        ...state,
        uploadingCampaniaMaterial: action.payload,
      };

    case types.setDeletingCampaniaMaterial:
      return {
        ...state,
        deletingCampaniaMaterial: action.payload,
      };

      case types.setLoadingCampos:
      return {
        ...state,
        loadingCampos: action.payload,
      };

    default:
      return state;
  }
};
